import { render, staticRenderFns } from "./ImageGalery.vue?vue&type=template&id=5a7a489d&scoped=true&"
import script from "./ImageGalery.vue?vue&type=script&lang=js&"
export * from "./ImageGalery.vue?vue&type=script&lang=js&"
import style0 from "./ImageGalery.vue?vue&type=style&index=0&id=5a7a489d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a489d",
  null
  
)

export default component.exports